export enum DocumentEditFieldType {
    TEXT = 'TEXT',
    CHECKBOX = 'CHECKBOX',
    RADIO = 'RADIO',
    SELECT = 'SELECT',
    GROUP = 'GROUP',
    DATEPICKER = 'DATEPICKER'
}

export interface DocumentEditField {
    checkboxes?: DocumentEditField[];
    editable: boolean;
    groupId: string;
    groupName: string;
    label: string;
    name: string;
    options: { label: string; value: string }[];
    order?: number;
    required: boolean;
    type: DocumentEditFieldType;
    value: string;
}

export function createDocumentEditField(data: any): DocumentEditField {
    return {
        editable: data.editable === '-1',
        groupId: data.groupid ?? '0',
        groupName: data.groupname ?? '',
        label: data.label,
        name: data.name,
        options: data.options ? JSON.parse(data.options) : [],
        order: data.order === '' ? null : Number(data.order),
        required: data.required === '-1',
        type: DocumentEditFieldType[data.type.toUpperCase()],
        value: data.value
    };
}
